var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "route-login" },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "content-holder" },
          [
            _vm._m(0),
            !_vm.finished
              ? [
                  _c("h1", [_vm._v("Wachtwoord vergeten")]),
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(
                      "Ben je je wachtwoord vergeten? Voer je e-mail adres in en er zal een e-mail worden gestuurd met daarin een knop om een nieuw wachtwoord in te stellen."
                    ),
                  ]),
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("cms-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'",
                          },
                        ],
                        attrs: {
                          type: "email",
                          name: "email",
                          placeholder: "E-mail adres",
                          "data-vv-as": "E-mail adres",
                          error: _vm.error("email"),
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                      _c(
                        "cms-button",
                        {
                          attrs: { loading: _vm.submitting },
                          on: { click: _vm.submit },
                        },
                        [_vm._v("Verzenden")]
                      ),
                      _c("input", {
                        staticStyle: { display: "none" },
                        attrs: { type: "submit" },
                      }),
                    ],
                    1
                  ),
                ]
              : [
                  _c("h1", [_vm._v("E-mail verzonden")]),
                  _c("span", { staticClass: "subtitle" }, [
                    _vm._v(
                      "Als je e-mail adres bekend is, is er zojuist een e-mail verzonden met daarin een knop om een nieuw wachtwoord in te stellen."
                    ),
                  ]),
                ],
            _c(
              "div",
              { staticClass: "nav-link" },
              [
                _c("router-link", { attrs: { to: { name: "login" } } }, [
                  _vm._v("Terug"),
                ]),
              ],
              1
            ),
          ],
          2
        ),
      ]),
      _c("toast-container"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logos-holder" }, [
      _c("div", { staticClass: "logo" }, [
        _c("i", { staticClass: "img logo-aveco-color-180" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }